if (!customElements.get('nikuya-reviews')) {
  customElements.define('nikuya-reviews', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.rows = Array.from(this.querySelectorAll('.nikuya-pdp-09__row'));
      this.button = this.querySelector('.nikuya-pdp-09__more');
      if (!this.button || !this.rows.length) return;
      this.status = this.querySelector('.nikuya-pdp-09__status');
      this.breakpoint = window.matchMedia('(min-width: 1024px)');
      this.initial = () => this.breakpoint.matches ? (this.dataset.desktopCount === '5' ? 5 : 6) : 4;
      this.visible = this.initial();
      this.update = (announce = false) => {
        this.rows.forEach((row, index) => { row.hidden = index >= this.visible; });
        if (this.status) this.status.textContent = announce ? this.dataset.statusLabel.replace('__visible__', String(Math.min(this.visible, this.rows.length))) : '';
        this.button.hidden = this.rows.length <= this.initial();
        this.button.textContent = this.visible >= this.rows.length ? this.dataset.fewerLabel : this.dataset.moreLabel;
      };
      this.button.addEventListener('click', () => {
        this.visible = this.visible >= this.rows.length ? this.initial() : Math.min(this.rows.length, this.visible + (this.breakpoint.matches ? 6 : 4));
        this.update(true);
      }, { signal });
      this.breakpoint.addEventListener('change', () => {
        this.visible = this.initial();
        this.update(true);
      }, { signal });
      this.update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.rows?.forEach(row => { row.hidden = false; });
      if (this.button) this.button.hidden = true;
    }
  });
}
